import { createContext, useContext } from "react";

export type HeaderMediaEditContextValue = {
  /** Opens the header photo manager for the given headerImages slot. */
  onEditSlot: (slotIndex: number) => void;
};

/**
 * Provided by EditableHeader in the customize preview so modular media that
 * cannot use fixed absolute pencils (e.g. animated Marquee) can render
 * per-frame edit controls that travel with the images.
 */
const HeaderMediaEditContext =
  createContext<HeaderMediaEditContextValue | null>(null);

export const HeaderMediaEditProvider = HeaderMediaEditContext.Provider;

export const useHeaderMediaEdit = (): HeaderMediaEditContextValue | null =>
  useContext(HeaderMediaEditContext);
